import React, { MouseEventHandler, useEffect, useState } from "react";
import Badge from "../../../components/Badge";
import Button from "../../../components/Button";
import Loader from "../../../components/Loader";
import H4 from "../../../components/Typography/H4";
import { useFetchApi } from "../../../hooks/useFetchApi";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import routes from "../../../setup/routes";
import TextFieldWithLabel from "../../../components/TextFieldWithLabel";

const NewRolePermissions: React.FC = (): React.ReactElement => {
  const navigate = useNavigate();
  const [role, setRole] = useState<any>({ name: "", status: false });
  const [updatedPermissions, setUpdatedPermission] = useState<Array<any>>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const {
    execute: getPermissions,
    loading,
    response: permissions,
  } = useFetchApi("/api/permissions", {}, "GET");

  const handleOnSuccess = () => {
    // getPermissions();
    navigate(`${routes.DASHBOARD}/${routes.USER_MANAGEMENT}/${routes.ROLES}`);
  };

  const { execute: addNewRolePermission } = useFetchApi(
    `/api/roles/new/permissions`,
    {},
    "POST",
    handleOnSuccess
  );

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    if (permissions && !loading) {
      const updatedPerm = permissions.map((permission: any) => {
        return {
          key: permission.action_keys,
          entitlement_id: permission.id,
          checked: false,
        };
      });
      setUpdatedPermission(updatedPerm);
    }
  }, [permissions, loading]);

  const handleChange = (e: any) => {
    const id = e.target.id;
    const updateKey = e.target.value;
    if (["role_name"].includes(id)) {
      setRole({
        ...role,
        [id.split("_")[1]]: updateKey,
      });
    } else {
      setUpdatedPermission(
        updatedPermissions.map((permission: any) => {
          if (permission.key === updateKey) {
            return {
              ...permission,
              checked: !permission.checked,
            };
          }
          return permission;
        })
      );
    }
  };

  const handleUpdate = () => {
    console.log("u", updatedPermissions);
    addNewRolePermission({
      role_permissions: updatedPermissions,
      role,
    });
  };

  const handleSelectAll = () => {
    setUpdatedPermission(
      updatedPermissions.map((permission: any) => {
        return {
          ...permission,
          checked: !selectAll,
        };
      })
    );
    setSelectAll(!selectAll);
  };
  useEffect(() => {
    console.log("con", role);
  }, [role]);

  return (
    <div className="flex flex-col w-full p-8">
      <Loader show={loading} />
      <div className="flex justify-between mb-8 text-white">
        <H4>Role Permissions</H4>
        <Button id="newEdit" onClick={handleUpdate} variant="primary">
          Add Role & Permissions
        </Button>
      </div>
      <div className="flex w-full justify-end items-center">
        <Button onClick={handleSelectAll}>
          {!selectAll ? "Select All" : "Unselect All"}
        </Button>
      </div>
      <div className="flex flex-col bg-white rounded-lg p-4 w-6/12 items-start">
        {role ? (
          <>
            <TextFieldWithLabel
              id="role_name"
              label="Role"
              value={role.name}
              onChange={handleChange}
            />
            <div className="flex gap-4">
              <label htmlFor="role_status">Status:</label>
              <input
                id="role_status"
                type="checkbox"
                checked={role.status}
                onChange={() => {
                  setRole({
                    ...role,
                    status: !role.status,
                  });
                }}
              />
            </div>
          </>
        ) : null}
      </div>
      <div className="flex">
        <table className="w-full">
          <thead>
            <tr>
              <td className="p-2 border-b">Key</td>
              <td className="p-2 border-b">Status</td>
            </tr>
          </thead>
          {updatedPermissions && updatedPermissions.length ? (
            <tbody>
              {updatedPermissions.map((permission: any) => (
                <tr
                  className="border-b hover:bg-secondary cursor-pointer"
                  key={permission.key}
                >
                  <td className="p-2">{permission.key}</td>
                  <td className="p-2">
                    <input
                      type="checkbox"
                      value={permission.key}
                      checked={permission.checked}
                      onClick={handleChange}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          ) : null}
        </table>
      </div>
    </div>
  );
};

export default NewRolePermissions;
